import { useState } from 'react';
import MoveStageModal from './MoveStageModal';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';

export default function useMoveStageModal() {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [dataroomItem, setDataroomItem] = useState<IDataroomListItem | null>(null);

  const showMoveStageModal = (item: IDataroomListItem) => {
    setDataroomItem(item);
    setIsVisible(true);
  };

  const hideMoveStageModal = () => {
    setDataroomItem(null);
    setIsVisible(false);
  };

  return {
    MoveStageModal,
    dataroomItem,
    showMoveStageModal,
    hideMoveStageModal,
    isVisible,
  };
}
